import { FONT_SIZE_MEDIUM } from '~/Constants/UI.constants';
import {
  BORDER_COLOR,
  WHITE,
  BORDER_COLOR_SHADE_2,
  CHARCOAL_GREY,
  VERTICAL_SEPARATOR,
  CHIP_BACKGROUND_GRAY,
} from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

export const EventPageFloatingPanelStyles = () =>
  makeStyles((theme) => ({
    EventPageFloatingInfoPanelContainer: {
      display: 'flex',
      margin: '-22px 0 24px 0',
      [theme.breakpoints.up('md')]: {
        margin: 0,
      },
    },
    EventPageFloatingInfoPanel: {
      zIndex: 1,
      border: `thin solid ${BORDER_COLOR}`,
      borderRadius: 3,
      backgroundColor: WHITE,
      boxShadow: '0 0 5px 0 rgba(210,210,210,0.5)',
      margin: '0 15px',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        margin: '0 -7px',
        width: 'calc(100% + 14px)',
      },
    },
    EventPageFloatingPanelItem: {
      height: 44,
      marginLeft: 15,
      display: 'flex',
      alignItems: 'center',
      fontSize: FONT_SIZE_MEDIUM,
      lineHeight: '22px',
      justifyContent: 'space-between',
      '&:not(:first-of-type)': {
        borderTop: `thin solid ${BORDER_COLOR_SHADE_2}`,
      },
    },
    EventPageFloatingPanelItemTextField: {
      paddingRight: 8,
    },
    EventPageFloatingPanelButtons: {
      fontWeight: 300,
      color: `${CHARCOAL_GREY} !important`,
    },
    EventPageFloatingPanelInput: {
      textAlignLast: 'left',
      width: '100%',
      display: 'flex',
      flex: 1,
      '& > div': {
        width: '100%',
        maxWidth: '100%',
      },
    },
    EventPageFloatingPanelTitle: {
      minWidth: 'fit-content',
      marginRight: '15px',
    },
    EventPageFloatingPanelLink: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textDecoration: 'none',
      width: '100%',
      height: 30,
    },
    TitleContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    LiveStreamContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      height: 90,
      border: `thin solid ${VERTICAL_SEPARATOR}`,
      borderTop: 'none',
      padding: '8px 15px',
    },
    castIcon: {
      height: 32,
      width: 32,
      borderRadius: 15,
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 24,
      backgroundColor: CHIP_BACKGROUND_GRAY,
      marginRight: 8,
    },
  }));
